<script>
  export let user
  export let size = 30
</script>

<img src='https://www.gravatar.com/avatar/{user.avatarHash}?s={size}&r=g'
    alt={user.nickname}
    class={$$props.class}>
